import { render, staticRenderFns } from "./GuestBookForm.vue?vue&type=template&id=248e9820&scoped=true&"
import script from "./GuestBookForm.vue?vue&type=script&lang=js&"
export * from "./GuestBookForm.vue?vue&type=script&lang=js&"
import style0 from "./GuestBookForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GuestBookForm.vue?vue&type=style&index=1&id=248e9820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e9820",
  null
  
)

export default component.exports